import { createAnimation } from '@ionic/core';

export const slideUp = baseEl => {
  const root = baseEl.shadowRoot;
  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop'))
    .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.ion-overlay-wrapper'))
    .delay(100)
    .keyframes([
      { offset: 0, opacity: '.5', transform: 'translateY(50vh)' },
      { offset: 1, opacity: '1', transform: 'translateY(0)' }
    ]);

  return createAnimation()
    .addElement(baseEl)
    .easing('ease-out')
    .duration(200)
    .addAnimation([backdropAnimation, wrapperAnimation]);
};

export const slideDown = baseEl => slideUp(baseEl).direction('reverse');

export const slideUpSelect = baseEl => {
  const root = baseEl;
  const backdropAnimation = createAnimation()
    .addElement(root?.querySelector('ion-backdrop'))
    .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

  const wrapperAnimation = createAnimation()
    .addElement(root?.querySelector('.ion-overlay-wrapper'))
    .delay(100)
    .keyframes([
      { offset: 0, opacity: '.5', transform: 'translateY(50vh)' },
      { offset: 1, opacity: '1', transform: 'translateY(0)' }
    ]);

  return createAnimation()
    .addElement(baseEl)
    .easing('ease-out')
    .duration(200)
    .addAnimation([backdropAnimation, wrapperAnimation]);
};

export const slideDownSelect = baseEl => slideUp(baseEl).direction('reverse');
